/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Focus_TimerInputs */

const en_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus Timer`)
};

const ar_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مؤقت التركيز`)
};

const de_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus-Timer`)
};

const es_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador de concentración`)
};

const fr_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuteur de concentration`)
};

const it_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer di concentrazione`)
};

const ja_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォーカスタイマー`)
};

const ko_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 타이머`)
};

const pt_br_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador`)
};

const ru_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таймер фокусировки`)
};

const th_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตัวจับเวลาการโฟกัส`)
};

const tr_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma Zamanlayıcısı`)
};

const zh_cn_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注计时`)
};

const zh_tw_focus_timer = /** @type {(inputs: Focus_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注計時`)
};

/**
* | output |
* | --- |
* | "Focus Timer" |
*
* @param {Focus_TimerInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const focus_timer = /** @type {((inputs?: Focus_TimerInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focus_TimerInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focus_timer(inputs)
	if (locale === "ar") return ar_focus_timer(inputs)
	if (locale === "de") return de_focus_timer(inputs)
	if (locale === "es") return es_focus_timer(inputs)
	if (locale === "fr") return fr_focus_timer(inputs)
	if (locale === "it") return it_focus_timer(inputs)
	if (locale === "ja") return ja_focus_timer(inputs)
	if (locale === "ko") return ko_focus_timer(inputs)
	if (locale === "pt_br") return pt_br_focus_timer(inputs)
	if (locale === "ru") return ru_focus_timer(inputs)
	if (locale === "th") return th_focus_timer(inputs)
	if (locale === "tr") return tr_focus_timer(inputs)
	if (locale === "zh_cn") return zh_cn_focus_timer(inputs)
	return zh_tw_focus_timer(inputs)
});